import { useMutation } from 'react-query';

import * as RestApi from 'core/network/RestApi';
import { generatePath } from 'react-router';
import { BulkRetargetingCampaignEndpoints } from '../constants';
import { OffsiteCampaignStatus } from 'models';

export type UpdateBulkRetargetingStatus =
  | OffsiteCampaignStatus.Draft
  | OffsiteCampaignStatus.Scheduled
  | OffsiteCampaignStatus.Triggered;

export interface UpdateBulkRetargetingCampaignStatusRequest {
  siteId: string;
  campaignId: string;
  state: UpdateBulkRetargetingStatus;
}

export const updateBulkRetargetingCampaignStatus = ({
  siteId,
  campaignId,
  state,
}: UpdateBulkRetargetingCampaignStatusRequest) => {
  return RestApi.patch<UpdateBulkRetargetingStatus, Pick<UpdateBulkRetargetingCampaignStatusRequest, 'state'>>(
    generatePath(BulkRetargetingCampaignEndpoints.PATCH, { siteId, campaignId }),
    {
      state,
    },
  );
};

export const useUpdateBulkRetargetingCampaignStatusMutation = () => {
  return useMutation((payload: UpdateBulkRetargetingCampaignStatusRequest) =>
    updateBulkRetargetingCampaignStatus(payload),
  );
};
